import { addCache } from 'api/caching'
import { getCerebroHeaders } from 'api/Cerebro/headers'
import { orgScopedApiClient } from 'api/orgScopedClient'
import {
    Product,
    ProductMetadata,
    ProductMetadataAsinTitle,
    Report,
} from 'types'

import {
    CerebroApiOptionsHeaders,
    CerebroBulkUpdateResponse,
    CerebroPaginatedResponse,
    CerebroResourceResponse,
} from '../types'

export const updateProduct = (
    productId: string,
    data: Record<string, unknown>
): Promise<CerebroResourceResponse<ProductMetadata>> =>
    orgScopedApiClient.patch(`/api/product/${productId}/`, data)

export const updateProducts = (
    data: any
): Promise<CerebroBulkUpdateResponse<ProductMetadata>> =>
    orgScopedApiClient.patch(`/api/products/`, data)

export const getProducts = (
    params: Record<string, unknown>,
    options: { headers: CerebroApiOptionsHeaders } = { headers: {} }
): Promise<CerebroPaginatedResponse<Product>> =>
    orgScopedApiClient.get('/api/products/', {
        params,
        headers: getCerebroHeaders(options.headers),
    })
addCache(getProducts)

export const getSovBrands = (
    params: Record<string, unknown>,
    options: { headers: CerebroApiOptionsHeaders } = { headers: {} }
): Promise<CerebroPaginatedResponse<string>> =>
    orgScopedApiClient.get(`/api/product_metadata/brands/`, {
        params,
        headers: getCerebroHeaders(options.headers),
    })
addCache(getSovBrands)

export const getProductMetadata = (
    params: Record<string, unknown>
): Promise<CerebroResourceResponse<ProductMetadata>> =>
    orgScopedApiClient.get(`/api/product_metadata/`, { params })
addCache(getProductMetadata)

/**
 * @param {string} params.marketplace The two-digit code of the marketplace to search for
 * @param {string} params.asins Comma-separated list of ASINs
 * @returns {Promise<CerebroPaginatedResponse<ProductMetadata>>}
 */
export const getProductMetadataOpenSearch = (
    params: Record<string, unknown>
): Promise<CerebroPaginatedResponse<ProductMetadata>> =>
    orgScopedApiClient.get(`/api/product_metadata_opensearch/`, {
        params,
    })
addCache(getProductMetadataOpenSearch)

export const getProductMetadataAsinTitles = (
    params: Record<string, unknown>,
    options: { headers: CerebroApiOptionsHeaders } = { headers: {} }
): Promise<CerebroPaginatedResponse<ProductMetadataAsinTitle>> =>
    orgScopedApiClient.get(`/api/product_metadata/asin_titles/`, {
        params,
        headers: getCerebroHeaders(options.headers),
    })
addCache(getProductMetadataAsinTitles)

export const getProductsAsyncExport = (
    params: Record<string, unknown>
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.get(`/api/product_catalog/export/async/`, {
        params,
    })
